// extracted by mini-css-extract-plugin
export var childrenContainer = "_db-0";
export var virtualScrollArea = "_db-1";